export const DataProvide = [
  {
    key: "provide1",
    title: "Поручительство основателя",
    descriptoin: "Основатель верит в проект и готов отвечать лично, если что-то пойдёт не так"
  },

  {
    key: "pprovide2",
    title: "Поручительство головной компании",
    descriptoin: "Отвечает не изолированное юрлицо, а гораздо большая бизнес-структура: холдинг, компания или группа компаний"
  },

  {
    key: "provide3",
    title: "Поручительство партнёров",
    descriptoin: "Ключевые бизнес-партнёры берут на себя часть обязательств перед инвестором"
  },

  {
    key: "provide4",
    title: "Залог оборудования",
    descriptoin: "Компания оформляет в залог оборудование, которое будет реализовано с молотка, если возникнет задолженность"
  },

  {
    key: "provide5",
    title: "Залог товара",
    descriptoin: "Часть товара в обороте компании. Если возникает задолженность, этот товар выходит из оборота — и продаётся с молотка"
  },

  {
    key: "provide6",
    title: "Залог недвижимости",
    descriptoin: "Работает как ипотека — недвижимость в залоге будет реализована с молотка, если возникнет задолженность"
  },

  {
    key: "provide7",
    title: "Банковские гарантии",
    descriptoin: "Независимая банковская гарантия. Если основной должник не вернул долг — деньги инвестору перечисляет банк"
  },

  {
    key: "provide8",
    title: "Неустойка",
    descriptoin:
      "Если заёмщик не выполняет условия договора, ему придётся платить штраф или пени. Штраф — это фиксированная сумма. Пени — процент от долга за каждый день просрочки"
  }
]
